import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../../api';
// 1. The "Library" function (CORRECTED for native fetch)
const fetchFolders = async (projectId,sectionId ) => {
  return await apiRequest(`/api/folders/${projectId}/${sectionId}`,{
    method: 'POST', // Explicitly set POST to match Flask
    body: JSON.stringify({}), // Send an empty object if no data is needed
  }); 
};

// CENTRAL TOP: Folders (scoped to Project + Section)
export const useSectionFolders = (projectId,sectionId) => {
  return useQuery({
	    queryKey: ['folders', projectId, sectionId],
	    queryFn: () => fetchFolders({ projectId, sectionId }),
	    enabled: !!projectId && !!sectionId,
  });
};